import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import {
  NEW_DESIGN_BUTTON_PROPS_V2,
  SOCIAL_MEDIA_CARD_OVERRIDES,
  SOCIAL_MEDIA_CATEGORIES,
  SOCIAL_MEDIA_CHANNELS_V2,
  VIDEO_CATEGORIES,
} from '../constants'
import { VideoCategories, VideosTabs } from '../Types'
import { useEffect, useState } from 'react'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'
import { NewDesignButtonV2, WizardButton, WizardCard } from '../WizardButton/WizardButton'
import { ChannelType } from 'components/CampaignCreationModal/Types'

export const Videos = (props: SectionProps) => {
  const subCategory = props.subCategory as VideoCategories
  const setSubCategory = props.setSubCategory
  const [selectedTab] = useState<VideosTabs>('popular')

  useEffect(() => {
    props.searchRef?.current?.focus()
  }, [selectedTab, props.searchRef])

  if (subCategory) {
    const newDesignButtonPropsV2 = NEW_DESIGN_BUTTON_PROPS_V2[subCategory]
    const categoryTitle = SOCIAL_MEDIA_CATEGORIES.find((c) => c?.name === subCategory)?.label

    return (
      <div className={Styles.commonSectionContainer}>
        <WizardCategoryCardGrid heading={`What ${categoryTitle} content do you want to make?`}>
          {SOCIAL_MEDIA_CHANNELS_V2[subCategory].map((channel) => (
            <WizardButton
              key={channel}
              channelKey={channel}
              version={2}
              size="lg"
              cardInfoOverride={SOCIAL_MEDIA_CARD_OVERRIDES}
              {...props}
            />
          ))}
          {newDesignButtonPropsV2 && <NewDesignButtonV2 {...newDesignButtonPropsV2} size="lg" />}
        </WizardCategoryCardGrid>
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <WizardCategoryCardGrid heading="Which platform do you want to create content for?">
        {VIDEO_CATEGORIES.map((category) => (
          <WizardCard
            size="md"
            key={category.name}
            title={category.label}
            image={category.image}
            onPress={() => setSubCategory(category.name)}
            {...props}
          />
        ))}
        <div className={Styles.commonInnerSection}>
          <WizardCategoryCardGrid heading="Popular">
            <WizardButton channelKey="tik-tok-post" version={2} size="lg" {...props} />
            <WizardButton channelKey={ChannelType.YoutubeScript} version={2} size="lg" {...props} />
            <WizardButton channelKey="instagram-reel" version={2} size="lg" {...props} />
          </WizardCategoryCardGrid>
        </div>
      </WizardCategoryCardGrid>
    </div>
  )
}
